// import createHistory from "history/createBrowserHistory";
import { createBrowserHistory } from "history";
export default createBrowserHistory(); // not sure why this is done this way but let's find out
